/* import __COLOCATED_TEMPLATE__ from './recommend-products.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import templateOnly from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    hasShopifyConnected: boolean;
    isMessengerInstalled: boolean;
  };
}

const RecommendProducts = templateOnly<Signature>();
export default RecommendProducts;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::RecommendProducts': typeof RecommendProducts;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/recommend-products': typeof RecommendProducts;
  }
}
